import React from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
// MSAL imports
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import store from "./app/store";
import { Provider } from "react-redux";
import CacheBuster from 'react-cache-buster';
import packageFile from '../package.json';

export const msalInstance = new PublicClientApplication(msalConfig);
// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
 // Account selection logic is app dependent. Adjust as needed for different use cases.
 msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
 if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
  const account = event.payload.account;
  msalInstance.setActiveAccount(account);
 }
});

const isProduction = process.env.NODE_ENV === 'production';
let { version } = packageFile;

window.__BASENAME__ = "/LKMTrainingNomination";
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <React.StrictMode>
      <BrowserRouter basename="/LKMTrainingNomination">
        <Provider store={store}>          
        <CacheBuster currentVersion={version} isEnabled={isProduction} isVerboseMode={false} metaFileDirectory={'.'}>
          <App pca={msalInstance}/>
        </CacheBuster>
        </Provider>
      </BrowserRouter>
    </React.StrictMode>,
  );